<template>
  <path
    d="M17 3.00024H7C5.9 3.00024 5.01 3.90024 5.01 5.00024L5 21.0002L12 18.0002L19 21.0002V5.00024C19 3.90024 18.1 3.00024 17 3.00024ZM17 18.0002L12 15.8202L7 18.0002V6.00024C7 5.45024 7.45 5.00024 8 5.00024H16C16.55 5.00024 17 5.45024 17 6.00024V18.0002Z"
  />
</template>
